import React from 'react'
import styled from 'styled-components'

const ToolbarContainer = styled.div`
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  display: flex;
  gap: 12px;
  padding: 12px 16px;
  background: rgba(26, 26, 26, 0.95);
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
`

const ToolButton = styled.button<{ $isActive?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: ${(props) =>
    props.$isActive ? 'linear-gradient(135deg, #3b82f6, #1d4ed8)' : 'rgba(255, 255, 255, 0.1)'};
  color: white;
  border: 1px solid
    ${(props) => (props.$isActive ? 'rgba(59, 130, 246, 0.5)' : 'rgba(255, 255, 255, 0.2)')};
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 120px;
  justify-content: center;

  &:hover {
    background: ${(props) =>
      props.$isActive ? 'linear-gradient(135deg, #2563eb, #1e40af)' : 'rgba(255, 255, 255, 0.15)'};
    border-color: ${(props) =>
      props.$isActive ? 'rgba(59, 130, 246, 0.7)' : 'rgba(255, 255, 255, 0.3)'};
    transform: translateY(-1px);
  }

  &:disabled {
    background: rgba(255, 255, 255, 0.05);
    color: rgba(255, 255, 255, 0.5);
    border-color: rgba(255, 255, 255, 0.1);
    cursor: not-allowed;
    transform: none;
  }

  i {
    font-size: 16px;
  }
`

export type MapTool = 'inference' | 'gegd' | null

interface MapToolbarProps {
  activeTool: MapTool
  onToolSelect: (tool: MapTool) => void
  onFilesDrop: (files: FileList) => void
  isDragActive: boolean
  hasSelectedModel: boolean
  onDragStateChange?: (isDragging: boolean) => void
}

const MapToolbar: React.FC<MapToolbarProps> = ({
  activeTool,
  onToolSelect,
  onFilesDrop,
  isDragActive,
  hasSelectedModel,
  onDragStateChange,
}) => {
  const handleToolClick = (tool: MapTool) => {
    if (activeTool === tool) {
      onToolSelect(null) // Deselect if clicking active tool
    } else {
      onToolSelect(tool)
    }
  }

  return (
    <>
      <ToolbarContainer>
        <ToolButton
          $isActive={activeTool === 'inference'}
          onClick={() => handleToolClick('inference')}
          disabled={!hasSelectedModel}
          title={
            !hasSelectedModel ? 'Please select a model first' : 'Click to activate inference mode'
          }
        >
          <i className="bi bi-cpu"></i>
          <span>Inference</span>
        </ToolButton>

        <ToolButton
          $isActive={activeTool === 'gegd'}
          onClick={() => handleToolClick('gegd')}
          disabled={true}
          title="GEGD tool - Coming soon"
        >
          <i className="bi bi-geo-alt"></i>
          <span>GEGD</span>
        </ToolButton>
      </ToolbarContainer>
    </>
  )
}

export default MapToolbar
